"use strict";

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/* eslint-disable dot-notation, no-param-reassign */
var Telepath = /*#__PURE__*/function () {
  function Telepath() {
    _classCallCheck(this, Telepath);

    this.constructors = {};
  }

  _createClass(Telepath, [{
    key: "register",
    value: function register(name, constructor) {
      this.constructors[name] = constructor;
    }
  }, {
    key: "unpack",
    value: function unpack(objData) {
      var packedValuesById = {};
      this.scanForIds(objData, packedValuesById);
      var valuesById = {};
      return this.unpackWithRefs(objData, packedValuesById, valuesById);
    }
  }, {
    key: "scanForIds",
    value: function scanForIds(objData, packedValuesById) {
      var _this = this;

      /* descend into objData, indexing any objects with an _id in packedValuesById */
      if (objData === null || _typeof(objData) !== 'object') {
        /* primitive value - nothing to scan */
        return;
      }

      if (Array.isArray(objData)) {
        /* scan recursively */
        objData.forEach(function (item) {
          return _this.scanForIds(item, packedValuesById);
        });
        return;
      }
      /* objData is an object / dict - check for reserved key names */


      var hasReservedKeyNames = false;

      if ('_id' in objData) {
        hasReservedKeyNames = true;
        /* index object in packedValuesById */

        packedValuesById[objData['_id']] = objData;
      }

      if ('_type' in objData || '_val' in objData || '_ref' in objData) {
        hasReservedKeyNames = true;
      }

      if ('_list' in objData) {
        hasReservedKeyNames = true;
        /* scan list items recursively */

        objData['_list'].forEach(function (item) {
          return _this.scanForIds(item, packedValuesById);
        });
      }

      if ('_args' in objData) {
        hasReservedKeyNames = true;
        /* scan arguments recursively */

        objData['_args'].forEach(function (item) {
          return _this.scanForIds(item, packedValuesById);
        });
      }

      if ('_dict' in objData) {
        hasReservedKeyNames = true;
        /* scan dict items recursively */
        // eslint-disable-next-line no-unused-vars

        for (var _i = 0, _Object$entries = Object.entries(objData['_dict']); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
              key = _Object$entries$_i[0],
              val = _Object$entries$_i[1];

          this.scanForIds(val, packedValuesById);
        }
      }

      if (!hasReservedKeyNames) {
        /* scan as a plain dict */
        // eslint-disable-next-line no-unused-vars
        for (var _i2 = 0, _Object$entries2 = Object.entries(objData); _i2 < _Object$entries2.length; _i2++) {
          var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
              _key = _Object$entries2$_i[0],
              _val = _Object$entries2$_i[1];

          this.scanForIds(_val, packedValuesById);
        }
      }
    }
  }, {
    key: "unpackWithRefs",
    value: function unpackWithRefs(objData, packedValuesById, valuesById) {
      var _this2 = this;

      if (objData === null || _typeof(objData) !== 'object') {
        /* primitive value - return unchanged */
        return objData;
      }

      if (Array.isArray(objData)) {
        /* unpack recursively */
        return objData.map(function (item) {
          return _this2.unpackWithRefs(item, packedValuesById, valuesById);
        });
      }
      /* objData is an object / dict - check for reserved key names */


      var result;

      if ('_ref' in objData) {
        if (objData['_ref'] in valuesById) {
          /* use previously unpacked instance */
          result = valuesById[objData['_ref']];
        } else {
          /* look up packed object and unpack it; this will populate valuesById as a side effect */
          result = this.unpackWithRefs(packedValuesById[objData['_ref']], packedValuesById, valuesById);
        }
      } else if ('_val' in objData) {
        result = objData['_val'];
      } else if ('_list' in objData) {
        result = objData['_list'].map(function (item) {
          return _this2.unpackWithRefs(item, packedValuesById, valuesById);
        });
      } else if ('_dict' in objData) {
        result = {};

        for (var _i3 = 0, _Object$entries3 = Object.entries(objData['_dict']); _i3 < _Object$entries3.length; _i3++) {
          var _Object$entries3$_i = _slicedToArray(_Object$entries3[_i3], 2),
              key = _Object$entries3$_i[0],
              val = _Object$entries3$_i[1];

          result[key] = this.unpackWithRefs(val, packedValuesById, valuesById);
        }
      } else if ('_type' in objData) {
        /* handle as a custom type */
        var constructorId = objData['_type'];
        var _constructor = this.constructors[constructorId];
        /* unpack arguments recursively */

        var args = objData['_args'].map(function (arg) {
          return _this2.unpackWithRefs(arg, packedValuesById, valuesById);
        });
        result = _construct(_constructor, _toConsumableArray(args));
      } else if ('_id' in objData) {
        throw new Error('telepath encountered object with _id but no type specified');
      } else {
        /* no reserved key names found, so unpack objData as a plain dict and return */
        result = {};

        for (var _i4 = 0, _Object$entries4 = Object.entries(objData); _i4 < _Object$entries4.length; _i4++) {
          var _Object$entries4$_i = _slicedToArray(_Object$entries4[_i4], 2),
              _key2 = _Object$entries4$_i[0],
              _val2 = _Object$entries4$_i[1];

          result[_key2] = this.unpackWithRefs(_val2, packedValuesById, valuesById);
        }

        return result;
      }

      if ('_id' in objData) {
        valuesById[objData['_id']] = result;
      }

      return result;
    }
  }]);

  return Telepath;
}();

module.exports = Telepath;